import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'helpers/moment';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSquare } from '@fortawesome/pro-solid-svg-icons';

import AttachmentsModal from 'bundles/apex/tasks/attachment_modal';

import './styles.scss';

export default function Status({
  addTaskAttachment,
  attachmentExceptions,
  attachmentsPath,
  deleteTaskAttachment,
  task,
  onUpdate,
}) {
  const [showAttachmentsModal, setShowAttachmentsModal] = useState(false);
  let statusClass = 'incomplete';
  let taskIcon = faSquare;

  if (task.completed) {
    statusClass = 'complete';
    taskIcon = faCheck;
  } else if (task.deadline) {
    if (task.deadline.date) {
      const today = moment().startOf('day');
      const deadline = moment(task.deadline.date);

      if (deadline.isBefore(today)) {
        statusClass = 'due';
      }
    }
  }

  const onModalHide = () => {
    setShowAttachmentsModal(false);
    if (task.attachments.length > 0) {
      onUpdate({ id: task.id, completed: true, path: task.path });
    }
  };

  const onModalSave = (task) => {
    onUpdate({
      ...task,
      completed: attachmentExceptions && !!task.attachmentExceptionReason,
    });
  };

  const toggleComplete = (e) => {
    e.stopPropagation();
    if (!task.completed && task.requiresAttachment && task.attachments.length === 0
      && (!attachmentExceptions || !task.attachmentExceptionReason)) {
      setShowAttachmentsModal(true);
    } else {
      onUpdate({ id: task.id, completed: !task.completed, path: task.path });
    }
  };

  return (
    <div aria-label="task status" className={`task-status ${statusClass} clickable`} onClick={toggleComplete}>
      <FontAwesomeIcon
        icon={taskIcon}
        inverse
      />
      <div onClick={e => e.stopPropagation()}>
        <AttachmentsModal
          addTaskAttachment={attachment => addTaskAttachment(task, attachment)}
          attachmentExceptions={attachmentExceptions}
          attachmentsPath={attachmentsPath}
          deleteTaskAttachment={attachment => deleteTaskAttachment(task, attachment)}
          show={showAttachmentsModal}
          task={task}
          onHide={onModalHide}
          onSave={onModalSave}
        />
      </div>
    </div>
  );
}

Status.propTypes = {
  addTaskAttachment: PropTypes.func.isRequired,
  attachmentExceptions: PropTypes.bool,
  attachmentsPath: PropTypes.string,
  deleteTaskAttachment: PropTypes.func.isRequired,
  task: PropTypes.object,
  onUpdate: PropTypes.func
};
